var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-start caption justify-start mx-5 px-3",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"d-flex align-start px-2"},[_c('div',{staticClass:"ml-2"},_vm._l((_vm.displayProductNames),function(product){return _c('div',{key:product.bsid},[_vm._v(_vm._s(product.names))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }